
import { empty as empty_1, ofList } from "../fable_modules/fable-library-js.5.3.0/Map.js";
import { ofSeq, ofArray, empty, maxBy, map } from "../fable_modules/fable-library-js.5.3.0/List.js";
import { compare } from "../fable_modules/fable-library-js.5.3.0/Date.js";
import { List_groupBy } from "../fable_modules/fable-library-js.5.3.0/Seq2.js";
import { equals, comparePrimitives, stringHash } from "../fable_modules/fable-library-js.5.3.0/Util.js";
import { Record, Union } from "../fable_modules/fable-library-js.5.3.0/Types.js";
import { unit_type, decimal_type, tuple_type, class_type, int32_type, list_type, record_type, bool_type, option_type, union_type, string_type } from "../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { UpdateDailyLogRequest_$reflection, AddDailyLogRequest_$reflection, GetHostDailyLogsResponse_$reflection, BulkUpdateTimesResponse_$reflection, PledgesByChallengeResponse_$reflection, FeePaymentResult_$reflection, DailyLogResponse_$reflection, FeeShareStatusResponse_$reflection, HostDailyLog_$reflection, ChallengePledgeItem_$reflection, PledgeResponse_$reflection, PledgeSummaryResponse_$reflection, FeeShareScheduleResponse_$reflection, ChallengeResponse_$reflection, UnloggedChallengeContext_$reflection, NotificationPreference_$reflection } from "./Shared.js";
import { UploadFailure_$reflection, UploadedPhoto_$reflection } from "./Photo.js";
import { ModerationReason_$reflection, ModerationStatusResponse_$reflection } from "./Moderation.js";
import { ApiError_$reflection } from "./ValidationErrors.js";
import { ListState, ListState_$reflection } from "./Challenge/ChallengeList.js";
import { LoggedDay_$reflection } from "./DailyLogEditWindow.js";
import { Result_Map, Result_MapError, FSharpResult$2 } from "../fable_modules/fable-library-js.5.3.0/Result.js";
import { isNullOrEmpty, printf, toText, isNullOrWhiteSpace } from "../fable_modules/fable-library-js.5.3.0/String.js";
import { UserNameModule_create, UserNameModule_value, EmailAddressModule_create, EmailAddressModule_value } from "./User.js";
import { isMatch } from "../fable_modules/fable-library-js.5.3.0/RegExp.js";
import { fromParts } from "../fable_modules/fable-library-js.5.3.0/Decimal.js";
import { Cmd_none } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";

/**
 * Build a Map<ChallengeId, PledgeSummaryResponse> from a list of pledge summaries.
 * When multiple pledges exist for the same challenge (e.g. cancelled then re-pledged),
 * the most recent pledge (by CreatedAt) wins.
 */
export function PledgeLookup_fromPledgeList(pledges) {
    return ofList(map((tupledArg) => [tupledArg[0], maxBy((p_1) => p_1.CreatedAt, tupledArg[1], {
        Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
    })], List_groupBy((p) => p.Challenge.ChallengeId, pledges, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    })), {
        Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
    });
}

export class ClientTypes_Route extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Home", "Challenges", "Challenge", "CreateChallenge", "CreateChallengeForCharity", "Profile", "ProfileComplete", "AuthCallback", "RegisterPage", "VerifyEmail", "Pledge", "ChallengePledges", "ChallengeLogs", "Privacy", "Terms", "Refunds", "FloodRelief"];
    }
}

export function ClientTypes_Route_$reflection() {
    return union_type("Shared.ClientTypes.Route", [], ClientTypes_Route, () => [[], [], [["id", string_type]], [], [["slug", string_type]], [], [], [], [], [["userId", string_type]], [["id", string_type]], [["id", string_type]], [["id", string_type]], [], [], [], []]);
}

export class ClientTypes_AuthState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Anonymous", "Authenticated", "Loading", "AccountSetupFailed", "UnderMaintenance"];
    }
}

export function ClientTypes_AuthState_$reflection() {
    return union_type("Shared.ClientTypes.AuthState", [], ClientTypes_AuthState, () => [[], [["token", string_type], ["email", option_type(string_type)], ["profileComplete", bool_type], ["monitoringId", option_type(string_type)]], [], [["reason", string_type]], []]);
}

export class ClientTypes_FormError extends Record {
    constructor(Field, Message) {
        super();
        this.Field = Field;
        this.Message = Message;
    }
}

export function ClientTypes_FormError_$reflection() {
    return record_type("Shared.ClientTypes.FormError", [], ClientTypes_FormError, () => [["Field", string_type], ["Message", string_type]]);
}

export class ClientTypes_OperationStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Idle", "InProgress", "Succeeded", "Failed"];
    }
}

export function ClientTypes_OperationStatus_$reflection() {
    return union_type("Shared.ClientTypes.OperationStatus", [], ClientTypes_OperationStatus, () => [[], [], [], [["Item", string_type]]]);
}

export class ClientTypes_ProfileFormData extends Record {
    constructor(Bio, ProfilePhotoUrl, Timezone, PreferredCharities) {
        super();
        this.Bio = Bio;
        this.ProfilePhotoUrl = ProfilePhotoUrl;
        this.Timezone = Timezone;
        this.PreferredCharities = PreferredCharities;
    }
}

export function ClientTypes_ProfileFormData_$reflection() {
    return record_type("Shared.ClientTypes.ProfileFormData", [], ClientTypes_ProfileFormData, () => [["Bio", string_type], ["ProfilePhotoUrl", string_type], ["Timezone", string_type], ["PreferredCharities", list_type(string_type)]]);
}

export class ClientTypes_ProfileCompletionState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ProfileNotStarted", "ProfileInProgress", "ProfileSubmitting", "ProfileSuccess", "ProfileFailed"];
    }
}

export function ClientTypes_ProfileCompletionState_$reflection() {
    return union_type("Shared.ClientTypes.ProfileCompletionState", [], ClientTypes_ProfileCompletionState, () => [[], [["Item1", ClientTypes_ProfileFormData_$reflection()], ["errors", list_type(ClientTypes_FormError_$reflection())]], [["Item", ClientTypes_ProfileFormData_$reflection()]], [], [["Item", string_type]]]);
}

export class ClientTypes_RegistrationFormData extends Record {
    constructor(Email, Password, ConfirmPassword, FirstName, LastName) {
        super();
        this.Email = Email;
        this.Password = Password;
        this.ConfirmPassword = ConfirmPassword;
        this.FirstName = FirstName;
        this.LastName = LastName;
    }
}

export function ClientTypes_RegistrationFormData_$reflection() {
    return record_type("Shared.ClientTypes.RegistrationFormData", [], ClientTypes_RegistrationFormData, () => [["Email", string_type], ["Password", string_type], ["ConfirmPassword", string_type], ["FirstName", string_type], ["LastName", string_type]]);
}

export class ClientTypes_RegistrationState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["RegistrationNotStarted", "RegistrationInProgress", "RegistrationSubmitting", "RegistrationSuccess", "RegistrationFailed"];
    }
}

export function ClientTypes_RegistrationState_$reflection() {
    return union_type("Shared.ClientTypes.RegistrationState", [], ClientTypes_RegistrationState, () => [[], [["Item1", ClientTypes_RegistrationFormData_$reflection()], ["errors", list_type(ClientTypes_FormError_$reflection())]], [["Item", ClientTypes_RegistrationFormData_$reflection()]], [["userId", string_type]], [["Item1", ClientTypes_RegistrationFormData_$reflection()], ["error", string_type]]]);
}

export class ClientTypes_VerificationSuccessData extends Record {
    constructor(SessionToken, Email) {
        super();
        this.SessionToken = SessionToken;
        this.Email = Email;
    }
}

export function ClientTypes_VerificationSuccessData_$reflection() {
    return record_type("Shared.ClientTypes.VerificationSuccessData", [], ClientTypes_VerificationSuccessData, () => [["SessionToken", option_type(string_type)], ["Email", option_type(string_type)]]);
}

export class ClientTypes_VerificationState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["VerificationNotStarted", "VerificationInProgress", "VerificationSubmitting", "VerificationAutoSubmitting", "VerificationSuccess", "VerificationFailed"];
    }
}

export function ClientTypes_VerificationState_$reflection() {
    return union_type("Shared.ClientTypes.VerificationState", [], ClientTypes_VerificationState, () => [[], [["code", string_type]], [["code", string_type]], [["code", string_type]], [], [["code", string_type], ["error", string_type]]]);
}

export class ClientTypes_RegField extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["FirstName", "LastName", "Email", "Password", "ConfirmPassword"];
    }
}

export function ClientTypes_RegField_$reflection() {
    return union_type("Shared.ClientTypes.RegField", [], ClientTypes_RegField, () => [[["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]]]);
}

export function ClientTypes_RegFieldModule_fieldName(_arg) {
    switch (_arg.tag) {
        case 1:
            return "lastName";
        case 2:
            return "email";
        case 3:
            return "password";
        case 4:
            return "confirmPassword";
        default:
            return "firstName";
    }
}

/**
 * Data loaded from the API for the profile page, before populating the UI state.
 * Used as the payload for ProfileDataLoaded message.
 */
export class ClientTypes_ProfileLoadedData extends Record {
    constructor(Timezone, PreferredChallengeTimeOfDay, PreferredReminderTimeOfDay) {
        super();
        this.Timezone = Timezone;
        this.PreferredChallengeTimeOfDay = PreferredChallengeTimeOfDay;
        this.PreferredReminderTimeOfDay = PreferredReminderTimeOfDay;
    }
}

export function ClientTypes_ProfileLoadedData_$reflection() {
    return record_type("Shared.ClientTypes.ProfileLoadedData", [], ClientTypes_ProfileLoadedData, () => [["Timezone", option_type(string_type)], ["PreferredChallengeTimeOfDay", option_type(string_type)], ["PreferredReminderTimeOfDay", option_type(string_type)]]);
}

/**
 * Full UI state for the loaded profile page, including time preference editing state.
 */
export class ClientTypes_ProfilePageData extends Record {
    constructor(Timezone, PreferredChallengeTime, PreferredReminderTime, OriginalChallengeTime, OriginalReminderTime, ReminderTimeManuallySet, ReminderOffset, TimesSaveStatus) {
        super();
        this.Timezone = Timezone;
        this.PreferredChallengeTime = PreferredChallengeTime;
        this.PreferredReminderTime = PreferredReminderTime;
        this.OriginalChallengeTime = OriginalChallengeTime;
        this.OriginalReminderTime = OriginalReminderTime;
        this.ReminderTimeManuallySet = ReminderTimeManuallySet;
        this.ReminderOffset = (ReminderOffset | 0);
        this.TimesSaveStatus = TimesSaveStatus;
    }
}

export function ClientTypes_ProfilePageData_$reflection() {
    return record_type("Shared.ClientTypes.ProfilePageData", [], ClientTypes_ProfilePageData, () => [["Timezone", option_type(string_type)], ["PreferredChallengeTime", string_type], ["PreferredReminderTime", string_type], ["OriginalChallengeTime", string_type], ["OriginalReminderTime", string_type], ["ReminderTimeManuallySet", bool_type], ["ReminderOffset", int32_type], ["TimesSaveStatus", ClientTypes_OperationStatus_$reflection()]]);
}

export class ClientTypes_ProfilePageState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ProfilePageNotLoaded", "ProfilePageLoading", "ProfilePageLoaded", "ProfilePageSaving", "ProfilePageError"];
    }
}

export function ClientTypes_ProfilePageState_$reflection() {
    return union_type("Shared.ClientTypes.ProfilePageState", [], ClientTypes_ProfilePageState, () => [[], [], [["Item", ClientTypes_ProfilePageData_$reflection()]], [], [["Item", string_type]]]);
}

/**
 * Novu-backed email preferences shown on the profile page. Independent of ProfilePageState so the two
 * loads can complete in either order. `pending` holds the workflow IDs with an in-flight PATCH, each
 * paired with the request id that PATCH was issued with — the UI disables a toggle while its workflow
 * ID is pending so a rapid double-click can't issue overlapping writes that could land out of order.
 * The request id lets a completion be matched against the pending entry it belongs to, so a save that
 * completes after a reload (or after a second toggle superseded it) is ignored instead of clobbering
 * newer state.
 */
export class ClientTypes_NotificationPreferencesState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["PreferencesNotLoaded", "PreferencesLoading", "PreferencesLoaded", "PreferencesError"];
    }
}

export function ClientTypes_NotificationPreferencesState_$reflection() {
    return union_type("Shared.ClientTypes.NotificationPreferencesState", [], ClientTypes_NotificationPreferencesState, () => [[], [], [["preferences", list_type(NotificationPreference_$reflection())], ["saveError", option_type(string_type)], ["pending", list_type(tuple_type(string_type, class_type("System.Guid")))]], [["Item", string_type]]]);
}

/**
 * Tracks which time-of-day settings changed on the profile page, used by the cascade prompt.
 * Time strings are in HH:mm format (24-hour).
 */
export class ClientTypes_ChangedTimeSettings extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ChallengeTimeOnly", "ReminderTimeOnly", "BothTimes"];
    }
}

export function ClientTypes_ChangedTimeSettings_$reflection() {
    return union_type("Shared.ClientTypes.ChangedTimeSettings", [], ClientTypes_ChangedTimeSettings, () => [[["timeStr", string_type]], [["timeStr", string_type]], [["challengeTimeStr", string_type], ["reminderTimeStr", string_type]]]);
}

/**
 * State machine for the cascade prompt shown after saving changed time preferences.
 */
export class ClientTypes_CascadePromptState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CascadeShown", "CascadeSubmitting", "CascadeSuccess", "CascadeError"];
    }
}

export function ClientTypes_CascadePromptState_$reflection() {
    return union_type("Shared.ClientTypes.CascadePromptState", [], ClientTypes_CascadePromptState, () => [[["challengeCount", int32_type], ["changed", ClientTypes_ChangedTimeSettings_$reflection()], ["updateChallenge", bool_type], ["updateReminder", bool_type]], [], [["updatedCount", int32_type]], [["message", string_type], ["changed", ClientTypes_ChangedTimeSettings_$reflection()], ["updateChallenge", bool_type], ["updateReminder", bool_type]]]);
}

/**
 * State machine for the daily log interception flow on the dashboard.
 * When an authenticated host visits the dashboard, the system checks for active
 * challenges missing today's log entry and prompts the host to log before proceeding.
 */
export class ClientTypes_DailyLogInterceptionState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotChecked", "Checking", "Prompting", "AllDone"];
    }
}

export function ClientTypes_DailyLogInterceptionState_$reflection() {
    return union_type("Shared.ClientTypes.DailyLogInterceptionState", [], ClientTypes_DailyLogInterceptionState, () => [[], [], [["challenges", list_type(UnloggedChallengeContext_$reflection())], ["currentIndex", int32_type], ["loggedCount", int32_type]], [["loggedCount", int32_type]]]);
}

/**
 * Which daily log form is open on the Manage page: add for a missing day, edit for a logged one.
 */
export class ClientTypes_DailyLogFormTarget extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AddLogFor", "EditLogFor"];
    }
}

export function ClientTypes_DailyLogFormTarget_$reflection() {
    return union_type("Shared.ClientTypes.DailyLogFormTarget", [], ClientTypes_DailyLogFormTarget, () => [[["Item", class_type("System.DateOnly")]], [["Item", class_type("System.DateOnly")]]]);
}

export class ClientTypes_PhotoUploadState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NoPhoto", "Uploading", "Uploaded", "ExistingPhoto", "UploadError"];
    }
}

export function ClientTypes_PhotoUploadState_$reflection() {
    return union_type("Shared.ClientTypes.PhotoUploadState", [], ClientTypes_PhotoUploadState, () => [[], [], [["Item", UploadedPhoto_$reflection()]], [["thumbnailUrl", string_type]], [["Item", UploadFailure_$reflection()]]]);
}

export class ClientTypes_PaymentState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["PaymentIdle", "PaymentLoading", "PaymentReady", "PaymentVerifying", "PaymentSucceeded", "PaymentVerificationTimedOut", "PaymentFailed"];
    }
}

export function ClientTypes_PaymentState_$reflection() {
    return union_type("Shared.ClientTypes.PaymentState", [], ClientTypes_PaymentState, () => [[], [], [["clientSecret", string_type]], [], [], [], [["Item", string_type]]]);
}

export class ClientTypes_PledgeFormState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["PledgeFormIdle", "PledgeFormEditing", "PledgeFormSubmitting", "PledgeFormError"];
    }
}

export function ClientTypes_PledgeFormState_$reflection() {
    return union_type("Shared.ClientTypes.PledgeFormState", [], ClientTypes_PledgeFormState, () => [[], [["amountInput", string_type], ["capAtGoal", bool_type], ["showLargeWarning", bool_type], ["acknowledgedLargeWarning", bool_type], ["showUncapWarning", bool_type]], [], [["Item", string_type]]]);
}

export class ClientTypes_SupportOthersSort extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ByEndDate", "ByStartDate", "ByTargetAmount"];
    }
}

export function ClientTypes_SupportOthersSort_$reflection() {
    return union_type("Shared.ClientTypes.SupportOthersSort", [], ClientTypes_SupportOthersSort, () => [[], [], []]);
}

export class ClientTypes_ThemePreference extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Light", "Dark", "System"];
    }
}

export function ClientTypes_ThemePreference_$reflection() {
    return union_type("Shared.ClientTypes.ThemePreference", [], ClientTypes_ThemePreference, () => [[], [], []]);
}

/**
 * Moderator panel on the challenge detail page. Present only once getModerationStatus
 * succeeded, which it does for moderators alone.
 */
export class ClientTypes_ModerationState extends Record {
    constructor(Status, Reason, LogDate, Busy, Error$) {
        super();
        this.Status = Status;
        this.Reason = Reason;
        this.LogDate = LogDate;
        this.Busy = Busy;
        this.Error = Error$;
    }
}

export function ClientTypes_ModerationState_$reflection() {
    return record_type("Shared.ClientTypes.ModerationState", [], ClientTypes_ModerationState, () => [["Status", ModerationStatusResponse_$reflection()], ["Reason", option_type(ModerationReason_$reflection())], ["LogDate", string_type], ["Busy", bool_type], ["Error", option_type(string_type)]]);
}

export class ClientTypes_Model extends Record {
    constructor(Input, Auth, EnsureRegisteredRequestId, AuthError, ShowUserMenu, CurrentRoute, PostRegistrationRoute, ProfileCompletion, ProfilePage, NotificationPreferences, Registration, Verification, CurrentChallenge, FeeShareSchedule, LoadingChallenge, ChallengeLoadError, Payment, PaymentVerificationAttempt, PaymentSessionId, Challenges, CompletedChallenges, CurrentUserId, PublicChallenges, SupportOthersSort, ThemePreference, ShowThemeMenu, ShowMobileMenu, PledgeForm, UserPledgeForChallenge, LoadingUserPledge, CurrentPledge, LoadingPledge, MyPledges, LoadingMyPledges, MyPledgesError, PledgeLookup, ChallengePledgeItems, ChallengePledgesCurrentPage, ChallengePledgesTotalPages, ChallengePledgesTotalItems, ChallengePledgesActivePledgeCount, ChallengePledgesActiveTotalPledged, ChallengePledgesAllLoaded, ChallengePledgesLoadingMore, ChallengePledgesLoadMoreError, LoadingChallengePledges, ChallengePledgesError, ShowAbandonedPledges, CascadePrompt, DailyLogInterception, DailyLogs, LoadingDailyLogs, DailyLogsError, DailyLogsHasMore, DailyLogsServerLoaded, LoadingMoreDailyLogs, DailyLogsLoadMoreError, LoggedDays, SubmittingDailyLog, DailyLogSubmitError, OpenDailyLogForm, DailyLogDraftHasInput, ShowAllMissedDays, FeeShareStatus, LoadingFeeShareStatus, FeeSharePollAttempts, PublicDailyLogs, LoadingPublicDailyLogs, PublicDailyLogsError, PublicDailyLogsHasMore, PublicDailyLogsPage, PhotoUpload, Moderation) {
        super();
        this.Input = Input;
        this.Auth = Auth;
        this.EnsureRegisteredRequestId = EnsureRegisteredRequestId;
        this.AuthError = AuthError;
        this.ShowUserMenu = ShowUserMenu;
        this.CurrentRoute = CurrentRoute;
        this.PostRegistrationRoute = PostRegistrationRoute;
        this.ProfileCompletion = ProfileCompletion;
        this.ProfilePage = ProfilePage;
        this.NotificationPreferences = NotificationPreferences;
        this.Registration = Registration;
        this.Verification = Verification;
        this.CurrentChallenge = CurrentChallenge;
        this.FeeShareSchedule = FeeShareSchedule;
        this.LoadingChallenge = LoadingChallenge;
        this.ChallengeLoadError = ChallengeLoadError;
        this.Payment = Payment;
        this.PaymentVerificationAttempt = (PaymentVerificationAttempt | 0);
        this.PaymentSessionId = PaymentSessionId;
        this.Challenges = Challenges;
        this.CompletedChallenges = CompletedChallenges;
        this.CurrentUserId = CurrentUserId;
        this.PublicChallenges = PublicChallenges;
        this.SupportOthersSort = SupportOthersSort;
        this.ThemePreference = ThemePreference;
        this.ShowThemeMenu = ShowThemeMenu;
        this.ShowMobileMenu = ShowMobileMenu;
        this.PledgeForm = PledgeForm;
        this.UserPledgeForChallenge = UserPledgeForChallenge;
        this.LoadingUserPledge = LoadingUserPledge;
        this.CurrentPledge = CurrentPledge;
        this.LoadingPledge = LoadingPledge;
        this.MyPledges = MyPledges;
        this.LoadingMyPledges = LoadingMyPledges;
        this.MyPledgesError = MyPledgesError;
        this.PledgeLookup = PledgeLookup;
        this.ChallengePledgeItems = ChallengePledgeItems;
        this.ChallengePledgesCurrentPage = (ChallengePledgesCurrentPage | 0);
        this.ChallengePledgesTotalPages = (ChallengePledgesTotalPages | 0);
        this.ChallengePledgesTotalItems = (ChallengePledgesTotalItems | 0);
        this.ChallengePledgesActivePledgeCount = (ChallengePledgesActivePledgeCount | 0);
        this.ChallengePledgesActiveTotalPledged = ChallengePledgesActiveTotalPledged;
        this.ChallengePledgesAllLoaded = ChallengePledgesAllLoaded;
        this.ChallengePledgesLoadingMore = ChallengePledgesLoadingMore;
        this.ChallengePledgesLoadMoreError = ChallengePledgesLoadMoreError;
        this.LoadingChallengePledges = LoadingChallengePledges;
        this.ChallengePledgesError = ChallengePledgesError;
        this.ShowAbandonedPledges = ShowAbandonedPledges;
        this.CascadePrompt = CascadePrompt;
        this.DailyLogInterception = DailyLogInterception;
        this.DailyLogs = DailyLogs;
        this.LoadingDailyLogs = LoadingDailyLogs;
        this.DailyLogsError = DailyLogsError;
        this.DailyLogsHasMore = DailyLogsHasMore;
        this.DailyLogsServerLoaded = (DailyLogsServerLoaded | 0);
        this.LoadingMoreDailyLogs = LoadingMoreDailyLogs;
        this.DailyLogsLoadMoreError = DailyLogsLoadMoreError;
        this.LoggedDays = LoggedDays;
        this.SubmittingDailyLog = SubmittingDailyLog;
        this.DailyLogSubmitError = DailyLogSubmitError;
        this.OpenDailyLogForm = OpenDailyLogForm;
        this.DailyLogDraftHasInput = DailyLogDraftHasInput;
        this.ShowAllMissedDays = ShowAllMissedDays;
        this.FeeShareStatus = FeeShareStatus;
        this.LoadingFeeShareStatus = LoadingFeeShareStatus;
        this.FeeSharePollAttempts = (FeeSharePollAttempts | 0);
        this.PublicDailyLogs = PublicDailyLogs;
        this.LoadingPublicDailyLogs = LoadingPublicDailyLogs;
        this.PublicDailyLogsError = PublicDailyLogsError;
        this.PublicDailyLogsHasMore = PublicDailyLogsHasMore;
        this.PublicDailyLogsPage = (PublicDailyLogsPage | 0);
        this.PhotoUpload = PhotoUpload;
        this.Moderation = Moderation;
    }
}

export function ClientTypes_Model_$reflection() {
    return record_type("Shared.ClientTypes.Model", [], ClientTypes_Model, () => [["Input", string_type], ["Auth", ClientTypes_AuthState_$reflection()], ["EnsureRegisteredRequestId", option_type(class_type("System.Guid"))], ["AuthError", option_type(string_type)], ["ShowUserMenu", bool_type], ["CurrentRoute", ClientTypes_Route_$reflection()], ["PostRegistrationRoute", option_type(ClientTypes_Route_$reflection())], ["ProfileCompletion", ClientTypes_ProfileCompletionState_$reflection()], ["ProfilePage", ClientTypes_ProfilePageState_$reflection()], ["NotificationPreferences", ClientTypes_NotificationPreferencesState_$reflection()], ["Registration", ClientTypes_RegistrationState_$reflection()], ["Verification", ClientTypes_VerificationState_$reflection()], ["CurrentChallenge", option_type(ChallengeResponse_$reflection())], ["FeeShareSchedule", option_type(FeeShareScheduleResponse_$reflection())], ["LoadingChallenge", bool_type], ["ChallengeLoadError", option_type(ApiError_$reflection())], ["Payment", ClientTypes_PaymentState_$reflection()], ["PaymentVerificationAttempt", int32_type], ["PaymentSessionId", option_type(string_type)], ["Challenges", ListState_$reflection()], ["CompletedChallenges", ListState_$reflection()], ["CurrentUserId", option_type(class_type("System.Guid"))], ["PublicChallenges", ListState_$reflection()], ["SupportOthersSort", ClientTypes_SupportOthersSort_$reflection()], ["ThemePreference", ClientTypes_ThemePreference_$reflection()], ["ShowThemeMenu", bool_type], ["ShowMobileMenu", bool_type], ["PledgeForm", ClientTypes_PledgeFormState_$reflection()], ["UserPledgeForChallenge", option_type(PledgeSummaryResponse_$reflection())], ["LoadingUserPledge", bool_type], ["CurrentPledge", option_type(PledgeResponse_$reflection())], ["LoadingPledge", bool_type], ["MyPledges", option_type(list_type(PledgeSummaryResponse_$reflection()))], ["LoadingMyPledges", bool_type], ["MyPledgesError", option_type(string_type)], ["PledgeLookup", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [class_type("System.Guid"), PledgeSummaryResponse_$reflection()])], ["ChallengePledgeItems", list_type(ChallengePledgeItem_$reflection())], ["ChallengePledgesCurrentPage", int32_type], ["ChallengePledgesTotalPages", int32_type], ["ChallengePledgesTotalItems", int32_type], ["ChallengePledgesActivePledgeCount", int32_type], ["ChallengePledgesActiveTotalPledged", decimal_type], ["ChallengePledgesAllLoaded", bool_type], ["ChallengePledgesLoadingMore", bool_type], ["ChallengePledgesLoadMoreError", option_type(string_type)], ["LoadingChallengePledges", bool_type], ["ChallengePledgesError", option_type(string_type)], ["ShowAbandonedPledges", bool_type], ["CascadePrompt", option_type(ClientTypes_CascadePromptState_$reflection())], ["DailyLogInterception", ClientTypes_DailyLogInterceptionState_$reflection()], ["DailyLogs", option_type(list_type(HostDailyLog_$reflection()))], ["LoadingDailyLogs", bool_type], ["DailyLogsError", option_type(string_type)], ["DailyLogsHasMore", bool_type], ["DailyLogsServerLoaded", int32_type], ["LoadingMoreDailyLogs", bool_type], ["DailyLogsLoadMoreError", option_type(string_type)], ["LoggedDays", list_type(LoggedDay_$reflection())], ["SubmittingDailyLog", bool_type], ["DailyLogSubmitError", option_type(string_type)], ["OpenDailyLogForm", option_type(ClientTypes_DailyLogFormTarget_$reflection())], ["DailyLogDraftHasInput", bool_type], ["ShowAllMissedDays", bool_type], ["FeeShareStatus", option_type(FeeShareStatusResponse_$reflection())], ["LoadingFeeShareStatus", bool_type], ["FeeSharePollAttempts", int32_type], ["PublicDailyLogs", list_type(DailyLogResponse_$reflection())], ["LoadingPublicDailyLogs", bool_type], ["PublicDailyLogsError", option_type(string_type)], ["PublicDailyLogsHasMore", bool_type], ["PublicDailyLogsPage", int32_type], ["PhotoUpload", ClientTypes_PhotoUploadState_$reflection()], ["Moderation", option_type(ClientTypes_ModerationState_$reflection())]]);
}

export class ClientTypes_Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetInput", "Login", "Register", "StartRegistration", "NavigateToRegister", "SignUpToPledge", "SignInToPledge", "FocusPledgeForm", "Logout", "CheckAuth", "AuthStateChanged", "ToggleUserMenu", "CloseUserMenu", "SetThemePreference", "ToggleThemeMenu", "CloseThemeMenu", "ToggleMobileMenu", "CloseMobileMenu", "UrlChanged", "UpdateProfileField", "SubmitProfile", "ProfileResult", "CheckProfileComplete", "ProfileCheckCompleted", "UpdateRegField", "SubmitRegistration", "RegistrationResult", "UpdateVerificationCode", "SubmitVerification", "AutoVerifyFromUrl", "VerificationResult", "ResendVerificationEmail", "ResendResult", "EnsureRegistered", "EnsureRegisteredCompleted", "EnsureRegisteredHitMaintenance", "SetAuthError", "NavigateTo", "LoadChallenge", "LoadPublicChallengeById", "ChallengeLoaded", "LoadFeeShareSchedule", "FeeShareScheduleLoaded", "LoadChallenges", "ChallengesLoaded", "LoadCompletedChallenges", "CompletedChallengesLoaded", "InitiatePayment", "PaymentSessionReady", "PaymentConfirmed", "StartPaymentVerification", "PaymentVerificationResult", "PaymentVerificationTimeout", "RetryPaymentVerification", "DismissPaymentError", "PublishChallenge", "ChallengePublished", "AbandonChallenge", "ChallengeAbandoned", "LoadProfilePage", "ProfileDataLoaded", "UpdateProfileTimezone", "SaveProfileTimezone", "SaveProfileTimezoneResult", "UpdatePreferredChallengeTime", "UpdatePreferredReminderTime", "SavePreferredTimes", "SavePreferredTimesResult", "LoadNotificationPreferences", "NotificationPreferencesLoaded", "ToggleNotificationPreference", "NotificationPreferenceSaved", "LoadPublicChallenges", "PublicChallengesLoaded", "SetSupportOthersSort", "UpdatePledgeAmount", "SetCapAtGoal", "AcknowledgeUncapWarning", "AcknowledgeLargeWarning", "SubmitPledge", "PledgeCreated", "LoadUserPledgeForChallenge", "UserPledgeForChallengeLoaded", "LoadPledge", "PledgeLoaded", "LoadMyPledges", "MyPledgesLoaded", "RetryLoadMyPledges", "LoadChallengePledges", "ChallengePledgesLoaded", "ToggleShowAbandonedPledges", "LoadMoreChallengePledges", "MoreChallengePledgesLoaded", "RetryLoadMoreChallengePledges", "CascadePromptCountLoaded", "ToggleCascadeUpdateChallenge", "ToggleCascadeUpdateReminder", "SubmitCascadeUpdate", "CascadeUpdateResult", "DismissCascadePrompt", "LoadDailyLogs", "DailyLogsLoaded", "LoadMoreDailyLogs", "MoreDailyLogsLoaded", "RefreshDailyLogs", "OpenDailyLogForm", "CloseDailyLogForm", "DailyLogDraftChanged", "ToggleShowAllMissedDays", "LoadFeeShareStatus", "FeeShareStatusLoaded", "SubmitDailyLog", "DailyLogSubmitted", "UpdateDailyLog", "DailyLogUpdateCompleted", "LoadPublicDailyLogs", "PublicDailyLogsLoaded", "LoadMorePublicDailyLogs", "MorePublicDailyLogsLoaded", "RetryLoadPublicDailyLogs", "CheckDailyLogInterception", "DailyLogInterceptionResult", "SkipDailyLogChallenge", "SkipAllDailyLogs", "SubmitInterceptionDailyLog", "InterceptionDailyLogSubmitted", "DailyLogInterceptionComplete", "CatchUpDailyLogs", "PhotoUploadStarted", "PhotoUploadCompleted", "PhotoUploadFailed", "PhotoRemoved", "LoadModerationStatus", "ModerationStatusLoaded", "SetModerationReason", "SetModerationLogDate", "HideChallengeRequested", "RestoreChallengeRequested", "HideDailyLogRequested", "HideCoverImageRequested", "RestoreCoverImageRequested", "RestoreDailyLogRequested", "SuspendAccountRequested", "ReinstateAccountRequested", "ModerationActionCompleted"];
    }
}

export function ClientTypes_Msg_$reflection() {
    return union_type("Shared.ClientTypes.Msg", [], ClientTypes_Msg, () => [[["Item", string_type]], [], [], [["returnRoute", ClientTypes_Route_$reflection()]], [], [["challengeId", string_type]], [["challengeId", string_type]], [["challengeId", string_type]], [], [], [["Item", ClientTypes_AuthState_$reflection()]], [], [], [["Item", ClientTypes_ThemePreference_$reflection()]], [], [], [], [], [["Item", ClientTypes_Route_$reflection()]], [["field", string_type], ["value", string_type]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]], [], [["isComplete", bool_type], ["userId", string_type]], [["Item", ClientTypes_RegField_$reflection()]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]], [["Item", string_type]], [["userId", string_type]], [["userId", string_type], ["code", string_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [ClientTypes_VerificationSuccessData_$reflection(), string_type], FSharpResult$2, () => [[["ResultValue", ClientTypes_VerificationSuccessData_$reflection()]], [["ErrorValue", string_type]]])]], [["userId", string_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]], [], [["requestId", class_type("System.Guid")], ["Item2", union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]], [["requestId", class_type("System.Guid")]], [["Item", option_type(string_type)]], [["Item", ClientTypes_Route_$reflection()]], [["id", string_type]], [["id", string_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [ChallengeResponse_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", ChallengeResponse_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]], [["Item", option_type(class_type("System.Guid"))]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [FeeShareScheduleResponse_$reflection(), string_type], FSharpResult$2, () => [[["ResultValue", FeeShareScheduleResponse_$reflection()]], [["ErrorValue", string_type]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(ChallengeResponse_$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(ChallengeResponse_$reflection())]], [["ErrorValue", string_type]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(ChallengeResponse_$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(ChallengeResponse_$reflection())]], [["ErrorValue", string_type]]])]], [["Item", class_type("System.Guid")]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [FeePaymentResult_$reflection(), string_type], FSharpResult$2, () => [[["ResultValue", FeePaymentResult_$reflection()]], [["ErrorValue", string_type]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]], [["challengeId", class_type("System.Guid")], ["sessionId", string_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]], [["attempt", int32_type]], [], [], [["Item", class_type("System.Guid")]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]], [["Item", class_type("System.Guid")]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [ClientTypes_ProfileLoadedData_$reflection(), string_type], FSharpResult$2, () => [[["ResultValue", ClientTypes_ProfileLoadedData_$reflection()]], [["ErrorValue", string_type]]])]], [["Item", string_type]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]], [["Item", string_type]], [["Item", string_type]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(NotificationPreference_$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(NotificationPreference_$reflection())]], [["ErrorValue", string_type]]])]], [["workflowId", string_type]], [["workflowId", string_type], ["enabled", bool_type], ["requestId", class_type("System.Guid")], ["Item4", union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(ChallengeResponse_$reflection()), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(ChallengeResponse_$reflection())]], [["ErrorValue", ApiError_$reflection()]]])]], [["Item", ClientTypes_SupportOthersSort_$reflection()]], [["Item", string_type]], [["Item", bool_type]], [], [], [["challengeId", class_type("System.Guid")]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [PledgeSummaryResponse_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", PledgeSummaryResponse_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]], [["Item", class_type("System.Guid")]], [["challengeId", class_type("System.Guid")], ["Item2", union_type("Microsoft.FSharp.Core.FSharpResult`2", [option_type(PledgeSummaryResponse_$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", option_type(PledgeSummaryResponse_$reflection())]], [["ErrorValue", string_type]]])]], [["id", string_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [PledgeResponse_$reflection(), string_type], FSharpResult$2, () => [[["ResultValue", PledgeResponse_$reflection()]], [["ErrorValue", string_type]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(PledgeSummaryResponse_$reflection()), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(PledgeSummaryResponse_$reflection())]], [["ErrorValue", ApiError_$reflection()]]])]], [], [["challengeId", class_type("System.Guid")], ["page", int32_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [PledgesByChallengeResponse_$reflection(), string_type], FSharpResult$2, () => [[["ResultValue", PledgesByChallengeResponse_$reflection()]], [["ErrorValue", string_type]]])]], [], [["Item", class_type("System.Guid")]], [["Item1", union_type("Microsoft.FSharp.Core.FSharpResult`2", [PledgesByChallengeResponse_$reflection(), string_type], FSharpResult$2, () => [[["ResultValue", PledgesByChallengeResponse_$reflection()]], [["ErrorValue", string_type]]])], ["challengeId", class_type("System.Guid")], ["includeAbandoned", bool_type]], [["Item", class_type("System.Guid")]], [["Item1", union_type("Microsoft.FSharp.Core.FSharpResult`2", [int32_type, string_type], FSharpResult$2, () => [[["ResultValue", int32_type]], [["ErrorValue", string_type]]])], ["Item2", ClientTypes_ChangedTimeSettings_$reflection()]], [], [], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [BulkUpdateTimesResponse_$reflection(), string_type], FSharpResult$2, () => [[["ResultValue", BulkUpdateTimesResponse_$reflection()]], [["ErrorValue", string_type]]])]], [], [["challengeId", class_type("System.Guid")]], [["challengeId", class_type("System.Guid")], ["Item2", union_type("Microsoft.FSharp.Core.FSharpResult`2", [GetHostDailyLogsResponse_$reflection(), string_type], FSharpResult$2, () => [[["ResultValue", GetHostDailyLogsResponse_$reflection()]], [["ErrorValue", string_type]]])]], [], [["challengeId", class_type("System.Guid")], ["Item2", union_type("Microsoft.FSharp.Core.FSharpResult`2", [GetHostDailyLogsResponse_$reflection(), string_type], FSharpResult$2, () => [[["ResultValue", GetHostDailyLogsResponse_$reflection()]], [["ErrorValue", string_type]]])]], [["challengeId", class_type("System.Guid")]], [["Item1", ClientTypes_DailyLogFormTarget_$reflection()], ["thumbnailUrl", option_type(string_type)]], [], [["hasInput", bool_type]], [], [["challengeId", class_type("System.Guid")]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [option_type(FeeShareStatusResponse_$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", option_type(FeeShareStatusResponse_$reflection())]], [["ErrorValue", string_type]]])]], [["Item", AddDailyLogRequest_$reflection()]], [["challengeId", class_type("System.Guid")], ["Item2", union_type("Microsoft.FSharp.Core.FSharpResult`2", [DailyLogResponse_$reflection(), string_type], FSharpResult$2, () => [[["ResultValue", DailyLogResponse_$reflection()]], [["ErrorValue", string_type]]])]], [["Item", UpdateDailyLogRequest_$reflection()]], [["challengeId", class_type("System.Guid")], ["Item2", union_type("Microsoft.FSharp.Core.FSharpResult`2", [DailyLogResponse_$reflection(), string_type], FSharpResult$2, () => [[["ResultValue", DailyLogResponse_$reflection()]], [["ErrorValue", string_type]]])]], [["challengeId", class_type("System.Guid")]], [["challengeId", class_type("System.Guid")], ["Item2", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(DailyLogResponse_$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(DailyLogResponse_$reflection())]], [["ErrorValue", string_type]]])]], [], [["challengeId", class_type("System.Guid")], ["Item2", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(DailyLogResponse_$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(DailyLogResponse_$reflection())]], [["ErrorValue", string_type]]])]], [["Item", class_type("System.Guid")]], [["now", class_type("System.DateTimeOffset")]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(UnloggedChallengeContext_$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(UnloggedChallengeContext_$reflection())]], [["ErrorValue", string_type]]])]], [], [["now", class_type("System.DateTimeOffset")]], [["Item", AddDailyLogRequest_$reflection()]], [["challengeId", class_type("System.Guid")], ["Item2", union_type("Microsoft.FSharp.Core.FSharpResult`2", [DailyLogResponse_$reflection(), string_type], FSharpResult$2, () => [[["ResultValue", DailyLogResponse_$reflection()]], [["ErrorValue", string_type]]])]], [], [["challengeId", class_type("System.Guid")]], [], [["Item", UploadedPhoto_$reflection()]], [["Item", UploadFailure_$reflection()]], [], [["challengeId", class_type("System.Guid")]], [["challengeId", class_type("System.Guid")], ["Item2", union_type("Microsoft.FSharp.Core.FSharpResult`2", [ModerationStatusResponse_$reflection(), string_type], FSharpResult$2, () => [[["ResultValue", ModerationStatusResponse_$reflection()]], [["ErrorValue", string_type]]])]], [["wireString", string_type]], [["Item", string_type]], [], [], [], [], [], [["Item", class_type("System.DateOnly")]], [], [], [["challengeId", class_type("System.Guid")], ["Item2", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]]]);
}

export const ClientTypes_emptyProfileForm = new ClientTypes_ProfileFormData("", "", "", empty());

export const ClientTypes_emptyRegistrationForm = new ClientTypes_RegistrationFormData("", "", "", "", "");

export function ClientTypes_Validation_validateEmail(email) {
    if (isNullOrWhiteSpace(email)) {
        return new FSharpResult$2(1, ["Email is required"]);
    }
    else {
        return Result_MapError((_arg) => "Invalid email format", Result_Map(EmailAddressModule_value, EmailAddressModule_create(email)));
    }
}

export function ClientTypes_Validation_validateName(fieldName, value) {
    if (isNullOrWhiteSpace(value)) {
        return new FSharpResult$2(1, [toText(printf("%s is required"))(fieldName)]);
    }
    else {
        return Result_MapError((_arg) => toText(printf("%s must be between 2 and 50 characters"))(fieldName), Result_Map(UserNameModule_value, UserNameModule_create(value)));
    }
}

export function ClientTypes_Validation_validatePassword(password) {
    if (isNullOrWhiteSpace(password)) {
        return new FSharpResult$2(1, ["Password is required"]);
    }
    else if (password.length < 8) {
        return new FSharpResult$2(1, ["Password must be at least 8 characters"]);
    }
    else if (!isMatch(/[A-Z]/gu, password)) {
        return new FSharpResult$2(1, ["Password must contain an uppercase letter"]);
    }
    else if (!isMatch(/[a-z]/gu, password)) {
        return new FSharpResult$2(1, ["Password must contain a lowercase letter"]);
    }
    else if (!isMatch(/[0-9]/gu, password)) {
        return new FSharpResult$2(1, ["Password must contain a number"]);
    }
    else if (!isMatch(/[!@#$%^&*(),.?"':{}|<>]/gu, password)) {
        return new FSharpResult$2(1, ["Password must contain a special character"]);
    }
    else {
        return new FSharpResult$2(0, [password]);
    }
}

export class ClientTypes_Validation_PasswordRequirement extends Record {
    constructor(Label, Met) {
        super();
        this.Label = Label;
        this.Met = Met;
    }
}

export function ClientTypes_Validation_PasswordRequirement_$reflection() {
    return record_type("Shared.ClientTypes.Validation.PasswordRequirement", [], ClientTypes_Validation_PasswordRequirement, () => [["Label", string_type], ["Met", bool_type]]);
}

export function ClientTypes_Validation_checkPasswordRequirements(password) {
    const notBlank = !isNullOrEmpty(password);
    return ofArray([new ClientTypes_Validation_PasswordRequirement("At least 8 characters", notBlank && (password.length >= 8)), new ClientTypes_Validation_PasswordRequirement("An uppercase letter", notBlank && isMatch(/[A-Z]/gu, password)), new ClientTypes_Validation_PasswordRequirement("A lowercase letter", notBlank && isMatch(/[a-z]/gu, password)), new ClientTypes_Validation_PasswordRequirement("A number", notBlank && isMatch(/[0-9]/gu, password)), new ClientTypes_Validation_PasswordRequirement("A special character", notBlank && isMatch(/[!@#$%^&*(),.?"':{}|<>]/gu, password))]);
}

export function ClientTypes_Validation_validatePasswordMatch(password, confirmPassword) {
    if (!equals(password, confirmPassword)) {
        return new FSharpResult$2(1, ["Passwords do not match"]);
    }
    else {
        return new FSharpResult$2(0, [password]);
    }
}

export function ClientTypes_validateRegistrationForm(form) {
    const errors = [];
    const matchValue = ClientTypes_Validation_validateName("First Name", form.FirstName);
    if (matchValue.tag === 0) {
    }
    else {
        void (errors.push(new ClientTypes_FormError("firstName", matchValue.fields[0])));
    }
    const matchValue_1 = ClientTypes_Validation_validateName("Last Name", form.LastName);
    if (matchValue_1.tag === 0) {
    }
    else {
        void (errors.push(new ClientTypes_FormError("lastName", matchValue_1.fields[0])));
    }
    const matchValue_2 = ClientTypes_Validation_validateEmail(form.Email);
    if (matchValue_2.tag === 0) {
    }
    else {
        void (errors.push(new ClientTypes_FormError("email", matchValue_2.fields[0])));
    }
    const matchValue_3 = ClientTypes_Validation_validatePassword(form.Password);
    if (matchValue_3.tag === 0) {
    }
    else {
        void (errors.push(new ClientTypes_FormError("password", matchValue_3.fields[0])));
    }
    const matchValue_4 = ClientTypes_Validation_validatePasswordMatch(form.Password, form.ConfirmPassword);
    if (matchValue_4.tag === 0) {
    }
    else {
        void (errors.push(new ClientTypes_FormError("confirmPassword", matchValue_4.fields[0])));
    }
    return ofSeq(errors);
}

/**
 * The message a generic Sign Up control dispatches from `current`: in-app sign-up that
 * returns to `current` once the email is verified, except from the sign-up and auth
 * pages themselves, which start a fresh sign-up with no return route.
 */
export function ClientTypes_signUpMsg(current) {
    switch (current.tag) {
        case 8:
        case 9:
        case 7:
            return new ClientTypes_Msg(4, []);
        default:
            return new ClientTypes_Msg(3, [current]);
    }
}

export function ClientTypes_init() {
    return [new ClientTypes_Model("", new ClientTypes_AuthState(0, []), undefined, undefined, false, new ClientTypes_Route(0, []), undefined, new ClientTypes_ProfileCompletionState(0, []), new ClientTypes_ProfilePageState(0, []), new ClientTypes_NotificationPreferencesState(0, []), new ClientTypes_RegistrationState(0, []), new ClientTypes_VerificationState(0, []), undefined, undefined, false, undefined, new ClientTypes_PaymentState(0, []), 0, undefined, new ListState(0, []), new ListState(0, []), undefined, new ListState(0, []), new ClientTypes_SupportOthersSort(0, []), new ClientTypes_ThemePreference(2, []), false, false, new ClientTypes_PledgeFormState(0, []), undefined, false, undefined, false, undefined, false, undefined, empty_1({
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }), empty(), 0, 0, 0, 0, fromParts(0, 0, 0, false, 0), false, false, undefined, false, undefined, false, undefined, new ClientTypes_DailyLogInterceptionState(0, []), undefined, false, undefined, false, 0, false, undefined, empty(), false, undefined, undefined, false, false, undefined, false, 0, empty(), false, undefined, false, 0, new ClientTypes_PhotoUploadState(0, []), undefined), Cmd_none()];
}

export function ClientTypes_initWithState(model) {
    return [model, Cmd_none()];
}

//# sourceMappingURL=ClientTypes.js.map
